/**
 * Formats the full name using setTitleCase
 *
 * @param {object} opts
 * @param {string} opts.firstname
 * @param {string} opts.firstName
 * @param {string|null} [opts.middlename]
 * @param {boolean} [opts.useMiddleInitial]
 * @param {boolean} [opts.excludeMiddleName]
 * @param {string} opts.lastname
 * @param {string} opts.lastName
 * @param {string} opts.defaultValue
 * @returns {string}
 */
const formatFullName = (opts = {}) => {
  if (!opts) return;

  const normalizedFirstName = opts.firstname ?? opts.firstName;
  const normalizedLastName = opts.lastname ?? opts.lastName;
  if (normalizedFirstName?.includes('new profile')) {
    // new profiles have a placeholder firstname and no last name
    return setTitleCase({ text: normalizedFirstName });
  }
  if (!normalizedFirstName || !normalizedLastName) {
    return opts?.defaultValue ?? '';
  }

  const firstName = setTitleCase({ text: normalizedFirstName });

  const lastName = setTitleCase({ text: normalizedLastName });

  let middleName = null;
  if (opts.middlename && opts.useMiddleInitial && !opts.excludeMiddleName) {
    middleName = opts.middlename.charAt(0);
  } else if (opts.middlename && !opts.excludeMiddleName) {
    middleName = setTitleCase({ text: opts.middlename });
  }

  return `${firstName}${middleName ? ` ${middleName} ` : ' '}${lastName}`;
};

export default formatFullName;
